/* eslint-disable */

import { CheckCircle2 } from 'lucide-react';


const EmptyState = ({ icon, title, description }) => {
    return (
        <div className="flex w-full flex-col items-center justify-center min-h-[70vh] py-4 px-4 text-center">
            <div className="mb-4 text-muted-foreground">
                {icon || <CheckCircle2 className="w-16 h-16" strokeWidth={1.5} />}
            </div>
            <h3 className="mb-2 text-foreground text-lg font-medium">{title}</h3>
            <p className="text-muted-foreground w-full">
                {description}
            </p>
        </div>
    );
}

export default EmptyState;
